import React from 'react';
import PropTypes from 'prop-types';
import { LogoFull } from '../../assets/icons';
import './AuthInfo.scss';

const AuthInfo = (props) => {
  return (
    <div className={props.className ? `auth__info ${props.className} ` : 'auth__info'}>
      <div className='auth__info__logo'>
        <LogoFull />
      </div>
      {props.title && <h2 className='auth__info__title'>{props.title}</h2>}
      {props.description && <div className='mb-24 auth__info__description'>{props.description}</div>}
      {props.note && <div className='auth__info__note'>{props.note}</div>}
      {props.children}
    </div>
  );
};

AuthInfo.propTypes = {
  className: PropTypes.string,
  title: PropTypes.element,
  description: PropTypes.element,
  note: PropTypes.element,
  children: PropTypes.any,
};

export default AuthInfo;
